import React, { useState, useMemo, useEffect } from "react";
import CreateCoachComponent from "../../components/CreateCoachComponent/CreateCoachComponent";
import { useHistory, useLocation } from "react-router-dom";
import {
  CREATE_COACH,
  UPDATE_COACH,
  UPDATE_WORKING_HOURS_COACH,
} from "../../GraphQL/Mutations";
import {
  ALL_LANGUAGES,
  ABOUT_USER,
  GET_DATA_COACH,
  ROLE_BY_LEVEL,
  COACHES_CANDIDATES,
} from "../../GraphQL/Queries";
import { useMutation, useLazyQuery } from "@apollo/client";
import { uploadFile, getFile } from "../../services/FileManager";
import { NotificationManager } from "react-notifications";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import PortalModal from "../../Portals";
import imgInfo from "../../assets/imgInfo.png";
import {
  ButtonOk,
  ContentModalCreate,
  CloseModalCreate,
  TextModalCreate,
} from "./CreateCoachContainer.styled";
import { parseISO8601Duration } from "../../util/UtilityFunctions";
import { clientWellness } from "../../App";
import moment from "moment";

const CreateCoachContainer = () => {
  const [fileName, setFileName] = useState();
  const [dataCoach, setDataCoach] = useState();
  const userComplete = useMemo(() => getStateLoginComplete(), []);
  const history = useHistory();
  const location = useLocation();
  const action = useMemo(() => location.state.action, []);
  const [usersForCoach, setUsersForCoach] = useState([]);
  const [coachEdit, setCoachEdit] = useState({});
  const [userSelected, setUserSelected] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [files, setFiles] = useState({});
  const [loadingCoverImage, setLoadingCoverImage] = useState(false);
  const [whsModified, setWhsModified] = useState(false);
  const [workingHours, setWorkingHours] = useState({
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  });
  const [showLoader, setShowLoader] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [runCreateCoach] = useMutation(CREATE_COACH, {
    client: clientWellness,
  });
  const [runUpdateCoach] = useMutation(UPDATE_COACH, {
    client: clientWellness,
  });
  const [runUpdateWorkingHoursCoach] = useMutation(UPDATE_WORKING_HOURS_COACH, {
    client: clientWellness,
  });
  const [allUserRoles, setAllUserRoles] = useState([]);
  const [runQueryAboutuser, { loading: loadingAboutuser }] = useLazyQuery(
    ABOUT_USER,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setUserSelected(data?.userAdminlistByIds[0]);
      },
    }
  );
  const [runGetDataCoach] = useLazyQuery(GET_DATA_COACH, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setCoachEdit(data.wellnessCoachById);
      if (data.wellnessCoachById.coverImage) {
        setLoadingCoverImage(true);
        getFile(data.wellnessCoachById.coverImage)
          .then((response) => {
            try {
              response.lastModifiedDate = new Date();
              response.name = data.wellnessCoachById.coverImage;
              const myFile = new File(
                [response],
                data.wellnessCoachById.coverImage,
                { type: response.type }
              );
              setFiles({ file: myFile });
              setLoadingCoverImage(false);
            } catch (error) {
              setLoadingCoverImage(false);

              const errorMessage = error.message.split("\n")[0];
              NotificationManager.error(errorMessage, "", 5000);
            }
          })
          .catch((error) => {
            setLoadingCoverImage(false);

            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          });
      }
      let whs = Object.assign({}, workingHours);
      Object.getOwnPropertyNames(workingHours).forEach((m) => {
        data.wellnessCoachById.wellnessCoachesWorkhours
          .filter((f) => f.weekday === m)
          .forEach((m) => { });
      });
      data.wellnessCoachById.wellnessCoachesWorkhours.map((m) => {
        let today = new Date();
        let dto = {
          start: parseISO8601Duration(m.startTime),
          end: parseISO8601Duration(m.finishTime),
        };
        let data = {
          start: new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDay(),
            parseInt(dto.start.hours),
            parseInt(dto.start.minutes)
          ),
          end: new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDay(),
            parseInt(dto.end.hours),
            parseInt(dto.end.minutes)
          ),
        };
        whs[m.weekday] = [...whs[m.weekday], data];
      });
      setWorkingHours(whs);
    },
  });
  const [runQueryCoachesCandidates, { loading: loadingCoachesCandidates }] =
    useLazyQuery(COACHES_CANDIDATES, {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let coachesCandidates = data.coachesCandidates.map((element) => {
          return {
            value: element?.userId,
            label: element?.userFullName + " ",
            userEmailAddress: element?.userEmailAddress,
          };
        });
        setUsersForCoach(coachesCandidates);
      },
    });
  const [runQueryAllRoles] = useLazyQuery(ROLE_BY_LEVEL, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let allRoles = data?.rolesByUserProfile?.map?.((element) => element.id);
      setAllUserRoles(allRoles);
    },
  });
  const [runQueryLanguages] = useLazyQuery(ALL_LANGUAGES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfLanguages = data?.allLanguages?.nodes?.map((element) => {
        return { value: element?.id, label: element?.name };
      });
      setLanguages(resultOfLanguages);
    },
  });

  useEffect(() => {
    if (
      (action === "add" && fileName && showLoader) ||
      (action === "add" && fileName === "" && showLoader)
    ) {
      handleCreateCoach();
    }
    if (
      (action === "edit" && fileName && showLoader) ||
      (action === "edit" && fileName === "" && showLoader)
    ) {
      handleUploadCoach();
    }
  }, [fileName, action, showLoader]);

  let handleUploadCoach = () => {
    if (
      typeof dataCoach?.Description === "string" &&
      dataCoach?.Description.length <= 500
    ) {
      runUpdateCoach({
        variables: {
          input: {
            coachId: location.state.coachId,
            languageIds: dataCoach?.Languages?.value
              ? dataCoach?.Languages?.value.map((m) => m.value)
              : dataCoach?.Languages?.map((m) => m.value),
            yearsExperience: parseInt(dataCoach?.Experience),
            yearsTp: parseInt(dataCoach?.Years),
            position: dataCoach?.Position,
            description: dataCoach?.Description,
            coverImage: fileName ? fileName : "",
          },
        },
      })
        .then((response) => {
          setShowLoader(false);
          if (response.errors) {
            NotificationManager.error(response.errors[0].message, "", 5000);
          } else {
            if (response.data.updateCoach.idCoach > 0) {
              setOpenModal(true);
            } else NotificationManager.warning("Update coach failed", "", 5000);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setShowLoader(false);
        });
    } else {
      NotificationManager.warning(
        "Character limit exceeded. Please limit your input to 500 characters on the description",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  let handleCreateCoach = () => {
    let workingHoursSave = [];
    Object.getOwnPropertyNames(workingHours).forEach((m) => {
      workingHours[m].forEach((h) => {
        let startTime = `PT${moment(h.start).format("HH")}H${moment(
          h.start
        ).format("mm")}M`;
        let finishTime = `PT${moment(h.end).format("HH")}H${moment(
          h.end
        ).format("mm")}M`;
        workingHoursSave.push({
          weekday: m.toUpperCase(),
          startTime: startTime,
          finishTime: finishTime,
        });
      });
    });

    if (workingHoursSave.length > 0) {
      if (
        typeof dataCoach?.Description === "string" &&
        dataCoach?.Description.length <= 500
      ) {
        runCreateCoach({
          variables: {
            input: {
              languageIds: dataCoach?.Languages.value.map((m) => m.value),
              yearsExperience: parseInt(dataCoach?.Experience),
              yearsTp: parseInt(dataCoach?.Years),
              position: dataCoach?.Position,
              description: dataCoach?.Description,
              userId: dataCoach?.User?.value?.value,
              workingHours: workingHoursSave,
              coverImage: fileName ? fileName : "",
            },
          },
        })
          .then((response) => {
            setShowLoader(false);
            if (response.errors) {
              NotificationManager.error(response.errors[0].message, "", 5000);
            } else {
              if (response.data.createCoach.idCoach > 0) {
                setOpenModal(true);
              } else NotificationManager.warning("Save coach failed", "", 5000);
            }
          })
          .catch((error) => {
            if (error.message) {
              const errorMessage = error.message.split("\n")[0];
              NotificationManager.error(errorMessage, "", 5000);
              setShowLoader(false);
            }
          });
      } else {
        NotificationManager.warning(
          "Character limit exceeded. Please limit your input to 500 characters on the description",
          "",
          5000
        );
        setShowLoader(false);
      }
    } else {
      NotificationManager.warning("The working hours are mandatory", "", 5000);
      setShowLoader(false);
    }
  };

  const createNew = (object, folderName) => {
    setShowLoader(true);
    if (object.file) {
      uploadFile([object.file], folderName)
        .then((imageName) => {
          let arrayNames = JSON.parse(imageName);
          setFileName(arrayNames[0].newName);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      setFileName("");
    }
    setDataCoach(object);
  };

  const updateOld = (object, folderName) => {
    setShowLoader(true);
    if (object?.file?.name?.indexOf("/") === -1) {
      uploadFile([object.file], folderName)
        .then((imageName) => {
          let arrayNames = JSON.parse(imageName);
          setFileName(arrayNames[0].newName);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else if (object?.file) {
      if (object.file.name.indexOf("/") !== -1) {
        setFileName(object.file.name);
      }
    } else {
      setFileName("");
    }
    setDataCoach(object);
  };

  const handleCallSpecificUser = (user) => {
    runQueryAboutuser({
      variables: { usersIds: [user.current.state.ariaSelection?.value?.value] },
      context: { clientName: "LinkUsers" },
    });
  };

  useEffect(() => {
    runQueryAllRoles({
      variables: { roleId: userComplete.roleId },
      context: { clientName: "LinkUsers" },
    });
  }, []);

  useEffect(() => {
    if (location.state.coachId) {
      runGetDataCoach({ variables: { idCoach: location.state.coachId } });
    }
    runQueryLanguages({ variables: { first: 25 } });
  }, [location.state.coachId]);

  useEffect(() => {
    if (!userComplete.roleId && Object.keys(coachEdit).length > 0) {
      return;
    }
    if (userComplete.roleId && Object.keys(coachEdit).length === 0) {
      runQueryAllRoles({
        variables: { roleId: userComplete.roleId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [userComplete]);

  useEffect(() => {
    if (!allUserRoles.length && Object.keys(coachEdit).length > 0) {
      return;
    }
    if (allUserRoles.length > 0 && Object.keys(coachEdit).length === 0) {
      runQueryCoachesCandidates({
        variables: { rolesId: allUserRoles },
      });
    }
  }, [allUserRoles]);

  return (
    <>
      {" "}
      <CreateCoachComponent
        languages={languages}
        usersForCoach={usersForCoach}
        workingHours={workingHours}
        userSelected={userSelected}
        coachEdit={coachEdit}
        files={files}
        setFiles={setFiles}
        setWhsModified={setWhsModified}
        setWorkingHours={setWorkingHours}
        createNew={createNew}
        updateOld={updateOld}
        action={action}
        handleCallSpecificUser={handleCallSpecificUser}
        loadingCoverImage={loadingCoverImage}
      ></CreateCoachComponent>{" "}
      {(loadingCoachesCandidates || loadingAboutuser) && (
        <ModalLoader></ModalLoader>
      )}{" "}
      {showLoader && <ModalLoader></ModalLoader>}{" "}
      {openModal && (
        <PortalModal>
          {" "}
          <ContentModalCreate>
            {" "}
            <CloseModalCreate>
              {" "}
              <span onClick={() => setOpenModal(false)}>X</span>{" "}
            </CloseModalCreate>{" "}
            <TextModalCreate>
              {" "}
              {action === "add" && (
                <>
                  {" "}
                  <img
                    src={imgInfo}
                    style={{ width: "11px", height: "24px" }}
                    alt=""
                  />{" "}
                  <p>Coach created successfully</p>{" "}
                </>
              )}{" "}
              {action === "edit" && (
                <>
                  {" "}
                  <img
                    src={imgInfo}
                    style={{ width: "11px", height: "24px" }}
                    alt=""
                  />{" "}
                  <p>User updated successfully</p>{" "}
                </>
              )}{" "}
            </TextModalCreate>{" "}
            {(action === "add" || action === "edit") && (
              <div
                style={{
                  display: "inline-flex",
                  margin: "auto",
                  width: "100%",
                }}
              >
                {" "}
                <ButtonOk
                  onClick={() => {
                    setOpenModal(false);
                    history.push("/CoachesManagement");
                  }}
                >
                  {" "}
                  Ok{" "}
                </ButtonOk>{" "}
              </div>
            )}{" "}
          </ContentModalCreate>{" "}
        </PortalModal>
      )}{" "}
    </>
  );
};
export default CreateCoachContainer;
